import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import * as moment from 'moment';


@Injectable()
export class DateTimeService {
  private selectedDate;
  constructor(private localSt: LocalStorageService) {
    this.localSt.observe('selectedDate').subscribe((data) => {
      this.selectedDate = data.fullDate;
    });
    if (this.localSt.retrieve('selectedDate') &&  this.localSt.retrieve('selectedDate').fullDate) {
      this.selectedDate = this.localSt.retrieve('selectedDate').fullDate;
    } else {
      this.selectedDate = this.formatDate(this.addDays(new Date(), 3));
    }
  }
  public getSelectedDate() {
    return this.selectedDate;
  }

  public formatDate(date) {
    let resDate = date.getFullYear() + '-';
    if (date.getMonth() + 1 < 10) {
      resDate += '0';
    }
    resDate += date.getMonth() + 1;
    if (date.getDate() < 10) {
      resDate += '-0';
    } else {
      resDate += '-';
    }
    return  resDate + date.getDate() ;
  }

  public addDays(date, days) {
      const result = new Date(date);
      result.setDate(date.getDate() + days);
      return result;
  }

  public getEditableOrderDate(holidaysList, orderDate) {
    let i = 1;
    let foundWorkingDays = 0;
    while(true) {
      const newDeliveryDate = moment(orderDate).subtract(i, 'days').toISOString();
      let isHoliday = false;
      const newDeliveryDateFormated = new Date(newDeliveryDate).toISOString().split('T')[0];
      for (let j = 0; j < holidaysList.length; j++) {
        const holidayDate = holidaysList[j];
        if (newDeliveryDateFormated === holidayDate) { 
          isHoliday = true;
        }
      }
      if(isHoliday || new Date(newDeliveryDate).getUTCDay() === 0) {
      } else {
        foundWorkingDays++;
      }
      if(foundWorkingDays===4 || foundWorkingDays>4) {
        break;
      }
      i++;
    }
    return i;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/date-time.service.ts